import { ChainId, JSBI, Percent, Token } from '@ekliptor/1bch-sdk'
import { mainnetTokens, testnetTokens } from './tokens'

//export const ROUTER_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E' // todo xxxxx // https://github.com/pancakeswap/pancake-swap-periphery/blob/master/contracts/PancakeRouter.sol
//export const ROUTER_ADDRESS = '0x4D0666Ed9407F6Fed245A0f8D8c51F79f0AbD08d'
//export const ROUTER_ADDRESS = '0xCd76AE4eb92d02bdbf22919Fe82Ae90B6C70ca13'
//export const ROUTER_ADDRESS = '0xA042cc68ED15700ED4dBc9A817a4846B9ab9aca6'
//export const ROUTER_ADDRESS = '0x7A6C3e4d87EB1c65680a0C05b6279480fd52B79F' // mainnet with bad pair
//export const ROUTER_ADDRESS = '0x3D6F2B755224450368f515447414883084D23831' // reverse swap bug
export const ROUTER_ADDRESS = '0x7363538e13632Ad2e1cb7aD6Cbd1EDd064EC943D'

/*
factory: 0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73 // https://github.com/1bch/pancake-swap-core/blob/master/contracts/PancakeFactory.sol
mine: 0xfF388901d68a38E950C5539eA23a4A5B538BDce0
  _feeToSetter: 0xcEba60280fb0ecd9A5A26A1552B90944770a4a0e
  mine: my wallte address
w...: 0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c // contract WBNB
mine: 0x5C3268F062bf24d0cfe976C481CA7deCb2AA4d15
*/

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  [ChainId.MAINNET]: [
    // todo
    mainnetTokens.wbch,
    mainnetTokens.bch1,
    mainnetTokens.rbch,

    // 3rd party pools
    mainnetTokens.flexusd,
    mainnetTokens.eben,
    mainnetTokens.tango,
    mainnetTokens.mist,
    mainnetTokens.flex,
    mainnetTokens.arg,
    mainnetTokens.cats,
    mainnetTokens.spice,
    mainnetTokens.axiebch,
    mainnetTokens.swabbit,
    mainnetTokens.bchpad,
    mainnetTokens.law,

    mainnetTokens.dtbch,
    mainnetTokens.dtusd,

    /*mainnetTokens.wbnb,
    mainnetTokens.cake,
    mainnetTokens.busd,
    mainnetTokens.usdt,
    mainnetTokens.btcb,
    mainnetTokens.ust,
    mainnetTokens.eth,
    mainnetTokens.usdc,*/
  ],
  //[ChainId.TESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.TESTNET]: [
    testnetTokens.wbch, // todo xxxx
    testnetTokens.rbch, // cake
    //testnetTokens.tbch, // syrup
    testnetTokens.bch1,
    testnetTokens.tt1,
    testnetTokens.tt2,
    testnetTokens.tt3,
    testnetTokens.tt4,
    testnetTokens.tt5,
    testnetTokens.tt6,
    testnetTokens.tt7,
    testnetTokens.tt8,
  ],
}

/**
 * Addittional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */
export const ADDITIONAL_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
  [ChainId.TESTNET]: {},
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WETH[ChainId.MAINNET]]
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
  [ChainId.TESTNET]: {},
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  //[ChainId.MAINNET]: [mainnetTokens.busd, mainnetTokens.cake, mainnetTokens.btcb],
  //[ChainId.TESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.MAINNET]: [/*todo*/
    mainnetTokens.wbch,
    mainnetTokens.bch1,
    mainnetTokens.rbch,

    // 3rd party pools
    mainnetTokens.flexusd,
    mainnetTokens.eben,
    mainnetTokens.tango,
    mainnetTokens.mist,
    mainnetTokens.flex,
    mainnetTokens.arg,
    mainnetTokens.cats,
    mainnetTokens.spice,
    mainnetTokens.axiebch,
    mainnetTokens.swabbit,
    mainnetTokens.bchpad,
    mainnetTokens.law,

    mainnetTokens.dtbch,
    mainnetTokens.dtusd,],
  [ChainId.TESTNET]: [testnetTokens.wbch, testnetTokens.rbch, testnetTokens.tt1, testnetTokens.tt2, testnetTokens.tt3, testnetTokens.tt4
    , testnetTokens.tt5, testnetTokens.tt6, testnetTokens.tt7, testnetTokens.tt8],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  //[ChainId.MAINNET]: [mainnetTokens.wbnb, mainnetTokens.dai, mainnetTokens.busd, mainnetTokens.usdt],
  //[ChainId.TESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.MAINNET]: [/*todo*/
    mainnetTokens.wbch,
    mainnetTokens.bch1,
    mainnetTokens.rbch,

    // 3rd party pools
    mainnetTokens.flexusd,
    mainnetTokens.eben,
    mainnetTokens.tango,
    mainnetTokens.mist,
    mainnetTokens.flex,
    mainnetTokens.arg,
    mainnetTokens.cats,
    //mainnetTokens.spice,
    //mainnetTokens.axiebch,
    //mainnetTokens.swabbit,
    mainnetTokens.bchpad,
    mainnetTokens.law,

    mainnetTokens.dtbch,
    mainnetTokens.dtusd,],
  [ChainId.TESTNET]: [testnetTokens.wbch, testnetTokens.rbch, testnetTokens.tt1, testnetTokens.tt2, testnetTokens.tt3, testnetTokens.tt4
    , testnetTokens.tt5, testnetTokens.tt6, testnetTokens.tt7, testnetTokens.tt8],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [
    /*[mainnetTokens.cake, mainnetTokens.wbnb],
    [mainnetTokens.busd, mainnetTokens.usdt],
    [mainnetTokens.dai, mainnetTokens.usdt],*/
    // todo

    [mainnetTokens.wbch, mainnetTokens.bch1],
    [mainnetTokens.wbch, mainnetTokens.rbch],
    [mainnetTokens.wbch, mainnetTokens.flexusd],
  ],
  [ChainId.TESTNET]: [
    /*[mainnetTokens.cake, mainnetTokens.wbnb],
    [mainnetTokens.busd, mainnetTokens.usdt],
    [mainnetTokens.dai, mainnetTokens.usdt],*/
    [testnetTokens.rbch, testnetTokens.wbch],
    [testnetTokens.tt2, testnetTokens.tt1],
    [testnetTokens.tt2, testnetTokens.tt3],
    [testnetTokens.tt4, testnetTokens.tt2],
  ],
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much BNB so they end up with <.01
export const MIN_BNB: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 BNB
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C',
]

export { default as farmsConfig } from './farms'
export { default as poolsConfig } from './pools'
export { default as ifosConfig } from './ifo'
